export const deliverymethod = {
    title: 'Delivery method',
    delivery: 'Delivery',
    no_delivery: 'No Delivery',
    self_pickup: 'Self-Pickup',
    no_self_pickup: 'No Self-Pickup',
    delivery_to: 'Deliver to',

    start_your_order: 'Start your order',
    please_select_address: 'Please select your address',
    please_select_branch: 'Please select your branch',

    select_add: "Select / Add",
    if_you_change: "If you change delivery address or pickup store, some item prices can vary by location.",

    select_time: 'Select time',
    now: 'Now',
    wait_cooked: '(estimate time 30 mins)',

    apply: 'Order',
    
    select_title: "Select Branch",
    nearby: "Near by",
    select_branch: "Select branch",
    pickup_at: "Pickup at",
    takeaway: "Takeaway",
    dinein: "Dine in",
    at_specific_time: "At specific time",

    branch_closed: "(Temporary Closed)",
    popup_confirm_clear: {
        msg: "Change order method? (Delivery / Self-Pickup) To change order method, we need to clear your cart first.",
        ok: "OK",
        cancel: "Cancel"
    },
    out_of_area: 'Out of delivery service',
};
